export default __webpack_public_path__ + "static/media/amper-2020.b69b0be5.png";